import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import nexapi from '../../services/api';
import { DivisionModel } from '../../types/models/DivisionModel';


interface DivisionResponse{
  data: DivisionModel[];
  totalCount: number;
}

interface DivisionState {
  data: DivisionModel[];
  totalRecords: number;
  currentPage: number;
  loading: boolean;
  error: string | null;
  status: string | null;
}

const initialState: DivisionState = {
  data: [],
  totalRecords: 0,
  currentPage: 1,
  loading: false,
  error: null,
  status: null
};

const API_URL = '/PettyCash';

export const fetchDivision = createAsyncThunk<DivisionResponse, {  
    filters: Record<string, any>;
    page: number; 
    numberOfRecord: number; 
    userId: string;
    sortColumn: string;
    sortOrder: 'asc' | 'desc';
    companyId:string;
    iscompanySubype : boolean;
  }>(
  'pettyCashDivision/fetchDivision',
  async ({filters, page, numberOfRecord, userId, sortColumn = '', sortOrder = 'asc', companyId,iscompanySubype }) => {
    try {
        
      // Construct the query string with filters
      const searchUnit =  filters.search || "";

      const url = `${API_URL}/GetDivision?pagination=true&page=${page}&numberOfRecord=${numberOfRecord}&userId=${userId}&search=${searchUnit}&sortColumn=${sortColumn}&sortOrder=${sortOrder}&companyId=${companyId}&state=${filters.state}&userTimeZone=${filters.userTimeZone}&isCompanyDivision=${iscompanySubype}`;

      const response = await nexapi.post(url);
      const data = response.data;
      if (Array.isArray(data?.data)) {
        return {
          data: data.data,
          totalCount: data.totalCount, 
        };
      } else {
        console.error('Invalid API Response:', data);
        return { data: [], totalCount: 0 }; // Return a fallback structure
      }
    } catch (error) {
      console.error('API Call Failed:', error);
      throw error;
    }
  }
);

export const activate = createAsyncThunk(
  'pettyCashDivision/activate', 
  async ({ id, userId }: { id: any; userId: any }) => { 
  try {
  await nexapi.post(`${API_URL}/ActivateDivision?id=${id}&userId=${userId}`);
  return id;
} catch (error) {
  return error.message
}
});

export const deactivate = createAsyncThunk(
  'pettyCashDivision/deactivate', 
  async ({ id,reason, userId }: { id: any; reason: any; userId: any }) => { 
  try {
  await nexapi.post(`${API_URL}/DeleteDivision?id=${id}&reason=${reason}&userId=${userId}`);
  return id;
} catch (error) {
  return error.message
}
});



export const deleteApplication = createAsyncThunk<DivisionResponse, { Id : string, UserId:string,reason: string}>(
  'pettyCashDivision/deleteApplication',
  async ({ Id,UserId,reason}) => {
    
    try {
      const [cleanId] = Id.includes('_') ? Id.split('_') : [Id];

      const payload = {
        Id: cleanId,
        UserId: UserId,
        reason: reason
      };
      const url = API_URL+"/ActivateDeactivateDivision";
      const method = "post";
      const response = await nexapi[method](url, payload);

      
      response.data.statusCode = "200";
      return response.data.statusCode;
    } catch (error) {
      console.error('API Call Failed:', error);
      throw error;
    }
  }
);

const requestsSlice = createSlice({
  name: 'pettyCashDivision',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDivision.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDivision.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.status = 'succeeded';
      })
      .addCase(fetchDivision.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch division';
      })
      .addMatcher(
        (action) => action.type.endsWith('/pending'),
        (state) => {
          state.status = 'loading';
        }
      )
      .addMatcher(
        (action) => action.type.endsWith('/rejected'),
        (state, action) => {
          state.status = 'failed';          
        }
      );
  },
});

export default requestsSlice.reducer;